import * as loginAPI from '../../login'
import store from '..'
const pushStore = {
  namespaced: true,

  state: {
    tabIdx: 1,
    CNT: 0,
    newNotice: {
      cnt: 0,
      ids: []
    },
    newBulletin: {
      cnt: 0,
      ids: []
    },
    newRequest: {
      cnt: 0,
      ids: []
    },
    newRequestStatus: {
      cnt: 0,
      ids: []
    },
    newIncongruity: {
      cnt: 0,
      ids: []
    },
    newIncongruityFeedBack: {
      cnt: 0,
      ids: []
    },
    newClient: {
      cnt: 0,
      ids: []
    },
    newClientConfirm: {
      cnt: 0,
      ids: []
    },
    newClientConfirmFinal: {
      cnt: 0,
      ids: []
    },
    newSpecimen: {
      cnt: 0,
      ids: []
    },

    newVOC: {
      cnt: 0,
      ids: []
    },

    newIssueReminder: {
      cnt: 0,
      ids: []
    },

    routerItem: {

    }
  },

  getters: {
    getTabIdx: state => state.tabIdx,
    getCNT: state => state.CNT,
    getNewNotice: state => state.newNotice,
    getNewBulletin: state => state.newBulletin,
    getNewRequest: state => state.newRequest,
    getNewRequestStatus: state => state.newRequestStatus,
    getNewIncongruity: state => state.newIncongruity,
    getNewIncongruityFeedBack: state => state.newIncongruityFeedBack,
    getNewClient: state => state.newClient,
    getNewClientConfirm: state => state.newClientConfirm,
    getNewSpecimen: state => state.newSpecimen,
    getNewClientConfirmFinal: state => state.newClientConfirmFinal,
    getNewVoc: state => state.newVOC,
    getIssueReminder: state => state.newIssueReminder,
    getRouterItem: state => state.routerItem
  },

  mutations: {

    mutationTabIdx: (state, payload) => {
      state.tabIdx = payload
    },

    mutationRouterItem: (state, payload) => {
      state.routerItem = payload
    },

    mutationNewCNT: (state, payload) => {
      state.CNT = payload
    },

    mutationNewCNT2: (state, payload) => {
      state.CNT += payload
    },

    mutationReset: (state, payload) => {
      loginAPI.newPush(payload.id, payload.password)
        .then((res) => {
          let pushList = res.data.result
          let cnt = 0
          store.commit('pushStore/resetState')
          for (let i = 0; i < pushList.length; i++) {
            let ids = pushList[i].id.split(',')
            cnt += ids.length
            let key = pushList[i].pushType
            store.commit('pushStore/mutationUpdateState', {
              key: key,
              ids: ids,
              isDelete: false
            })
          }
          store.commit('pushStore/mutationNewCNT', cnt)
        })
    },

    mutationUpdateState: (state, payload) => {
      const { key, ids, isDelete } = payload
      let cnt = 0
      if (state.hasOwnProperty(key)) {
        if (isDelete) {
          if (key === 'newSpecimen') {
            cnt = state.newSpecimen.ids.length
            store.commit('pushStore/mutationNewCNT2', -cnt)
          } else {
            cnt = 1
          }
          if (state[key].ids.includes(ids) && key !== 'newSpecimen') {
            state[key].ids = state[key].ids.filter(element => element !== ids)
            store.commit('pushStore/mutationNewCNT2', -cnt)
          }
        } else {
          state[key].ids = ids
        }
        // state.item

        // state[key].cnt = state[key].ids.length
        // state.CNT = 0
        // state.CNT = state.array.forEach(element => state.CNT += element.CNT);
      }
    },

    resetState: (state) => {
      state.CNT = 0;
      state.newNotice.cnt = 0;
      state.newNotice.ids = [];
      state.newBulletin.cnt = 0
      state.newBulletin.ids = []
      state.newRequest.cnt = 0;
      state.newRequest.ids = [];
      state.newRequestStatus.cnt = 0;
      state.newRequestStatus.ids = [];
      state.newIncongruity.cnt = 0;
      state.newIncongruity.ids = [];
      state.newIncongruityFeedBack.cnt = 0;
      state.newIncongruityFeedBack.ids = [];
      state.newClient.cnt = 0;
      state.newClient.ids = [];
      state.newClientConfirm.cnt = 0;
      state.newClientConfirm.ids = [];
      state.newClientConfirmFinal.cnt = 0;
      state.newClientConfirmFinal.ids = [];
      state.newSpecimen.cnt = 0;
      state.newSpecimen.ids = [];
      state.newVOC.cnt = 0;
      state.newVOC.ids = [];
      state.newIssueReminder.cnt = 0;
      state.newIssueReminder.ids = [];
    },

    resetRouterItem: (state, payload) => {
      state.routerItem = payload
    }

  }
}

export default pushStore
